import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';

import { Paper, IconButton } from '@material-ui/core';
import { AddCircleOutline as AddCircleOutlineIcon, Edit as EditIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  }
}));

const UsersTable = props => {
  const { users, rowsPerPage, page, usersCount, onChangePage, onChangeRowsPerPage, onClickAddUser, onClickEditUser } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <div>
        <IconButton onClick={onClickAddUser}>
          <AddCircleOutlineIcon />
        </IconButton>
      </div>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: '35%' }}>Номер телефона (логин)</TableCell>
              <TableCell align="center" style={{ width: '50%' }}>ФИО</TableCell>
              <TableCell align="center" style={{ width: '15%' }}>Изм.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((row) => (
              <TableRow key={"user_" + row.id}>
                <TableCell>{row.username}</TableCell>
                <TableCell>{row.lastname} {row.firstname} {row.middlename}</TableCell>
                <TableCell>
                  <IconButton onClick={() => onClickEditUser(row.id)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[1, 5, 10, 25]}
        component="div"
        count={usersCount}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Строк на странице"
        labelDisplayedRows={({ from, to, count }) => (`${from}-${to === -1 ? count : to} из ${count}`)}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </Paper>
  );
}

UsersTable.propTypes = {
  users: PropTypes.array,
  rowsPerPage: PropTypes.number,
  page: PropTypes.number,
  usersCount: PropTypes.number,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  onClickAddUser: PropTypes.func,
  onClickEditUser: PropTypes.func
};

export default UsersTable;